<template>
  <v-dialog v-model="manageFeedsInfoDialog" width="800">
    <v-card>
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <span class="display-1 text-uppercase font-weight-bold">{{$t('infoDialogs.private.manageFeeds.Title')}}</span>
        <v-spacer></v-spacer>
        <v-btn color="error" title="Lukk vindu" class="ma-2" outlined icon large @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <p class="pr-5 text--primary title">{{$t('infoDialogs.private.manageFeeds.PageDescription')}}.</p>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-row>
          <v-col md="11" class="ml-0 pl-0">
            <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.manageFeeds.PageActionsOne')}}:</span>
          </v-col>
          <v-col md="1">
            <v-icon large>far fa-edit</v-icon>
          </v-col>
          <v-col md="12">
            More to come, when page are completed
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// Import the i18n - This may need to be modified
import messages from "../../modules/lang/export";
export default {
  // Communicate with i18n
  i18n: { messages },
  data(){
    return{
      // Define the dialog v-model that we are using
      manageFeedsInfoDialog:false,
    }
  },
  methods: {
    // Opening the dialog through the ref
    openDialog() {
      this.manageFeedsInfoDialog = true;
    },
    // Close the dialog
    closeDialog() {
      this.manageFeedsInfoDialog = false;
    }
  }
}
</script>